<mat-card appearance="outlined" [ngStyle]="{'background-color':'#fff7b8'}" [ngClass] = "(deviceLg == true || deviceXl == true) ? 'brder-class m-10 m-xl-2 p-0' : 'brder-class p-0 mat-card-center'">
  <!-- <swiper
    [spaceBetween]="30"
    [centeredSlides]="true"
    [autoplay]="{
      delay: 5000,
      disableOnInteraction: true
    }"
    [pagination]="{
      clickable: true
    }"
    [navigation]="true"
    class="mySwiper"
  >

    <ng-template class="swiper-slide" swiperSlide >
      <div class="slide">
        <div class="header-container">

          <h4 class="header-title-content">Making Meetings Amazing Everywhere</h4>
        </div>
        <div>
          <div class="list-container">
            <ul class="ul-container">

                <li class="list-item"><h3>With all of its features, Agora creates clarity and efficiency in our meetings which contribute to the overall health and success of our organization.</h3></li>
							
						
                <li></li>
            </ul>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template class="swiper-slide" swiperSlide >
      <div class="slide-third">
        <div class="header-container">
          <h3 class="header-title-content">Announcement</h3>
        </div>
          <div class="list-container" *ngFor = "let accounce of annouceList">
            <ul class="ul-container">
              <li class="list-item"><h3 class="title-anchor">{{accounce}}</h3></li>
            </ul>
          </div>
      </div>
    </ng-template>
  </swiper> -->
  <carousel [noPause]="false" [isAnimated]="true">
    <slide [ngStyle]="{'height':'139px'}" *ngFor = "let announce of annouceList">
      <h2 class="text-center f-weight">Announcements</h2>
      <div class="carousel-caption d-block">
        <!-- <h3 class="text-left">First slide label</h3> -->
        <p [ngStyle]="{'color':'black'}">{{announce}}</p>
      </div>
    </slide>
  </carousel>
</mat-card>
